"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadReportFile = void 0;
var DownloadUtils = require("utils/download");
var downloadReportFile = function (file, callback) {
    var fileContent = file.fileContent, fileName = file.fileName;
    if (fileContent && fileName) {
        DownloadUtils.downloadBlob(fileContent, fileName);
        callback === null || callback === void 0 ? void 0 : callback();
    }
};
exports.downloadReportFile = downloadReportFile;
